import { getString, getInt } from '@ekd/env-config';
import { RedisClientOptions } from '@ekd/redis-client';

function retryStrategy(times: number) {
  const delay = Math.min(4 ** times * 10, 2000);

  return delay;
}

export default {
  enableRedis: true,
};

export const REDIS_CONFIG: RedisClientOptions = {
  keyPrefix: getString('REDIS_KEY_PREFIX', 'eg-local-portal-root:'),

  // Sentinel mode
  sentinels: getString('REDIS_SENTINEL_HOSTS', ''),
  sentinelName: getString('REDIS_SENTINEL_NAME', ''),
  sentinelPassword: getString('SENTINEL_PASSWORD', ''),

  // Plain connection
  host: getString('REDIS_HOST', 'localhost'),
  port: getInt('REDIS_PORT', 6379),
  password: getString('REDIS_PASSWORD', ''),
  redisOptions: {
    maxRetriesPerRequest: 4,
    retryStrategy,
    sentinelRetryStrategy: retryStrategy,
    enableAutoPipelining: true,
  },
};
